import {
  AdvokatselskabValues,
  ChangeAdvokatselskabPartner,
  ChangeInterestParty,
  ChangeAdvokatselskabValues,
  ChangeInteressentskabValues,
  CompanyShareholder,
  CompanyRegistrationValues,
  EmployeeListItem,
  InteressentskabValues,
  PNumberItem,
  ResponsibleParticipant,
  EnkeltmandsvirksomhedValues,
  TerminationValues,
} from "./registrationTypes";
import { LawyerOrLawFirmStatus } from "./registrationEnums";

export const createRegistrationRowId = (): string => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }

  return `row-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const emptyEmployee = (): EmployeeListItem => ({
  _rowId: createRegistrationRowId(),
  employeeName: "",
  employeeRole: "",
  employeeEmail: "",
  employeePhone: "",
});

export const emptyResponsibleParticipant = (): ResponsibleParticipant => ({
  _rowId: createRegistrationRowId(),
  participantType: "",
  name: "",
  email: "",
  cvrCpr: "",
  phone: "",
  isLawyerOrLawFirm: LawyerOrLawFirmStatus.Ja,
  passedPartnerExam: "",
  ownerShare: "",
  voteShare: "",
  leavesOtherOnEntry: "",
});

export const emptyShareholder = (): CompanyShareholder => ({
  _rowId: createRegistrationRowId(),
  name: "",
  isLawyerOrLawFirm: LawyerOrLawFirmStatus.Ja,
  passedPartnerExam: "",
  ownerShare: "",
  voteShare: "",
  cvrCpr: "",
  leavesOtherOnEntry: "",
});

export const emptyChangeInterestParty = (): ChangeInterestParty => ({
  _rowId: createRegistrationRowId(),
  name: "",
  cvrCpr: "",
  direction: "",
  isLawyerOrLawFirm: LawyerOrLawFirmStatus.Ja,
  passedPartnerExam: "",
  ownerShare: "",
  voteShare: "",
  leavesOtherOnEntry: "",
  otherCompanyName: "",
  participantType: "",
  withdrawalReason: "",
  continuedCompanyName: "",
  continuedCompanyCvr: "",
});

export const emptyChangeAdvokatselskabPartner =
  (): ChangeAdvokatselskabPartner => ({
    _rowId: createRegistrationRowId(),
    name: "",
    cvrCpr: "",
    direction: "",
    isLawyerOrLawFirm: LawyerOrLawFirmStatus.Ja,
    passedPartnerExam: "",
    ownerShare: "",
    voteShare: "",
    leavesOtherOnEntry: "",
    otherCompanyName: "",
    participantType: "",
    withdrawalReason: "",
    continuedCompanyName: "",
    continuedCompanyCvr: "",
  });

export const emptyPNumber = (): PNumberItem => ({
  _rowId: createRegistrationRowId(),
  value: "",
});

export const enkeltmandsvirksomhedInitialValues =
  (): EnkeltmandsvirksomhedValues => ({
    name: "",
    cvr: "",
    pNumber: "",
    phone: "",
    email: "",
    safetyEmail: "",
    invoiceTarget: "",
    invoiceEmail: "",
    eanNumber: "",
    website: "",
    remarks: "",
    cvrCreationDate: "",
    startDate: "",
    startFromOtherCompany: "",
    otherCompanyName: "",
    otherCompanyEndDate: "",
    employees: "",
    employeeList: [emptyEmployee()],
    insuranceCompany: "",
    insurancePolicyNumber: "",
    contactEmail: "",
    contactPhone: "",
  });

export const interessentskabInitialValues = (): InteressentskabValues => ({
  name: "",
  cvr: "",
  pNumber: "",
  phone: "",
  email: "",
  safetyEmail: "",
  website: "",
  invoiceTarget: "",
  invoiceEmail: "",
  eanNumber: "",
  responsibleParticipants: [
    emptyResponsibleParticipant(),
    emptyResponsibleParticipant(),
  ],
  remarks: "",
  cvrCreationDate: "",
  startDate: "",
  employees: "",
  employeeList: [emptyEmployee()],
  insuranceCompany: "",
  insurancePolicyNumber: "",
  contactEmail: "",
  contactPhone: "",
});

export const advokatselskabInitialValues = (): AdvokatselskabValues => ({
  name: "",
  cvr: "",
  pNumber: "",
  phone: "",
  email: "",
  safetyEmail: "",
  invoiceTarget: "",
  invoiceEmail: "",
  eanNumber: "",
  website: "",
  companyForm: "",
  shareholders: [emptyShareholder()],
  activePractice: "",
  employees: "",
  employeeList: [emptyEmployee()],
  remarks: "",
  cvrCreationDate: "",
  startDate: "",
  insuranceCompany: "",
  insurancePolicyNumber: "",
  contactEmail: "",
  contactPhone: "",
});

export const changeInteressentskabInitialValues =
  (): ChangeInteressentskabValues => ({
    name: "",
    cvr: "",
    pNumber: "",
    changeKind: "",
    interestParties: [emptyChangeInterestParty()],
    remarks: "",
    changeDate: "",
    contactEmail: "",
    contactPhone: "",
  });

export const changeAdvokatselskabInitialValues =
  (): ChangeAdvokatselskabValues => ({
    name: "",
    cvr: "",
    pNumber: "",
    changeKind: "",
    partners: [emptyChangeAdvokatselskabPartner()],
    remarks: "",
    changeDate: "",
    contactEmail: "",
    contactPhone: "",
  });

export const terminationInitialValues = (): TerminationValues => ({
  name: "",
  cvr: "",
  pNumbers: [emptyPNumber()],
  remarks: "",
  terminationDate: "",
  contactEmail: "",
  contactPhone: "",
});

export const companyRegistrationInitialValues =
  (): CompanyRegistrationValues => ({
    whatToRegister: "",
    companyType: "",
    enkeltmandsvirksomhed: enkeltmandsvirksomhedInitialValues(),
    interessentskab: interessentskabInitialValues(),
    advokatselskab: advokatselskabInitialValues(),
    changeInteressentskab: changeInteressentskabInitialValues(),
    changeAdvokatselskab: changeAdvokatselskabInitialValues(),
    termination: terminationInitialValues(),
  });
